import FilePickerViewState from '../store/schema/FilePickerViewState';
import { FileProviderViewState } from 'owa-fileprovider-store';
import { action } from 'satcheljs/lib/legacy';
import changeFilePickerView from './changeFilePickerView';
import changeUserPreferredViewType from './changeUserPreferredViewType';
import { FilePickerViewType } from '../types/FilePickerViewSwitcher';

export default action('toggleFilePickerView')(function toggleFilePickerView(
    selectedFileProvider: FileProviderViewState,
    viewState: FilePickerViewState,
    onViewTypeChanged?: (viewType: FilePickerViewType) => void
) {
    const { selectedView, supportedViews } = viewState;

    // We cycle between the supported views. If we change this pattern be sure to update
    // getAriaLabelForViewSwitcher in owa-filepicker/utils as we rely on this pattern
    // when generating aria labels for the view switcher button.
    const currentViewIndex = supportedViews.indexOf(selectedView);
    const nextViewIndex = currentViewIndex + 1 >= supportedViews.length ? 0 : currentViewIndex + 1;

    changeFilePickerView(supportedViews[nextViewIndex], selectedFileProvider, viewState);

    // If the user toggles the view then we set it as a preferred view
    const nextViewType = supportedViews[nextViewIndex];
    changeUserPreferredViewType(nextViewType, viewState);

    if (onViewTypeChanged) {
        onViewTypeChanged(nextViewType);
    }
});
